import React, { useState } from 'react';

const MyAccordian = ({ question, answer }) => {
  const [show, setShow] = useState(false);
  return (
    <article className={show ? 'faq-item open' : 'faq-item'}>
      <button className="faq-trigger" onClick={() => setShow(!show)} type="button">
        <span>{question}</span>
        <span className="faq-symbol">{show ? '−' : '+'}</span>
      </button>
      {show ? <p className="faq-answer">{answer}</p> : null}
    </article>
  );
};

export default MyAccordian;
